import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Table, Button, Form, InputGroup, Spinner, Pagination, Tabs, Tab } from 'react-bootstrap';
import { getApiUrl } from '../config/api';

const DataDivisi = () => {
  const navigate = useNavigate();
  const [time, setTime] = useState({ date: '', clock: '' });

  // Shared Config
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // State Divisi
  const [divisiList, setDivisiList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState('');
  
  // Pagination & Filter Divisi
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  // State Sub Divisi
  const [subDivisiList, setSubDivisiList] = useState([]);
  const [isLoadingSub, setIsLoadingSub] = useState(false);
  const [fetchErrorSub, setFetchErrorSub] = useState('');
  
  // Pagination & Filter Sub Divisi
  const [selectedKdDivisi, setSelectedKdDivisi] = useState('');
  const [searchSubQuery, setSearchSubQuery] = useState('');
  const [currentPageSub, setCurrentPageSub] = useState(1);

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      setTime({
        date: now.toLocaleDateString('id-ID', options),
        clock: now.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) + ' WIB'
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchDivisi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchSubDivisi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedKdDivisi]);

  const fetchDivisi = async () => {
    setIsLoading(true);
    setFetchError('');
    try {
      const res = await fetch(`${getApiUrl()}/show_divisi`);
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const data = await res.json();
      
      let list = [];
      if (data?.list_divisi && Array.isArray(data.list_divisi)) {
        list = data.list_divisi;
      } else if (Array.isArray(data)) {
        list = data;
      }
      setDivisiList(list);
    } catch (err) {
      console.error("Gagal fetch data divisi:", err);
      setFetchError('Gagal memuat data dari server. Pastikan backend aktif.');
      setDivisiList([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSubDivisi = async () => {
    setIsLoadingSub(true);
    setFetchErrorSub('');
    try {
      const url = selectedKdDivisi 
          ? `${getApiUrl()}/show_subdivisi?kd_divisi=${selectedKdDivisi}`
          : `${getApiUrl()}/show_subdivisi`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const data = await res.json();
      
      let list = [];
      if (data?.list_subdivisi && Array.isArray(data.list_subdivisi)) {
        list = data.list_subdivisi;
      } else if (Array.isArray(data)) {
        list = data;
      }
      setSubDivisiList(list);
    } catch (err) {
      console.error("Gagal fetch data sub divisi:", err);
      setFetchErrorSub('Gagal memuat data sub divisi dari server.');
      setSubDivisiList([]);
    } finally {
      setIsLoadingSub(false);
    }
  };

  // Filter Data Divisi
  const filteredDivisi = divisiList.filter(item => {
    if (!searchQuery) return true;
    const lowerQ = searchQuery.toLowerCase();
    return (
      (item.nm_divisi || '').toLowerCase().includes(lowerQ) ||
      (item.owner || '').toLowerCase().includes(lowerQ) ||
      (item.kd_divisi || '').toLowerCase().includes(lowerQ)
    );
  });

  // Filter Data Sub Divisi
  const filteredSubDivisi = subDivisiList.filter(item => {
    if (selectedKdDivisi && item.kd_divisi !== selectedKdDivisi) return false;
    if (!searchSubQuery) return true;
    const lowerQ = searchSubQuery.toLowerCase();
    return (
      (item.kode || '').toLowerCase().includes(lowerQ) ||
      (item.nik || '').toLowerCase().includes(lowerQ) ||
      (item.nm_divisi || '').toLowerCase().includes(lowerQ)
    );
  });

  // Pagination Logic Divisi
  const totalPages = Math.ceil(filteredDivisi.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredDivisi.slice(indexOfFirstItem, indexOfLastItem);

  // Pagination Logic Sub Divisi
  const totalPagesSub = Math.ceil(filteredSubDivisi.length / itemsPerPage);
  const indexOfLastItemSub = currentPageSub * itemsPerPage;
  const indexOfFirstItemSub = indexOfLastItemSub - itemsPerPage;
  const currentItemsSub = filteredSubDivisi.slice(indexOfFirstItemSub, indexOfLastItemSub);

  const styles = {
    appContainer: {
      height: '100vh',
      backgroundColor: '#f1f5f9',
      fontFamily: "'Inter', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    },
    navbarCustom: {
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
      padding: '0.2rem 0.8rem',
      flexShrink: 0,
    },
    mainContent: {
      padding: '0.8rem 1rem',
      flex: '1',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    }
  };

  return (
    <div style={styles.appContainer}>
      <style>{`
        .table-compact td, .table-compact th {
          padding: 0.2rem 0.4rem !important;
          vertical-align: middle;
          font-size: 0.78rem !important;
        }
        /* Fix for React-Bootstrap Tabs Flex Layout */
        .custom-tabs + .tab-content {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          min-height: 0;
        }
        .custom-tabs + .tab-content > .tab-pane {
          flex-grow: 1;
          display: flex !important;
          flex-direction: column;
          min-height: 0;
        }
        .custom-tabs + .tab-content > .tab-pane > .card {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          min-height: 0;
        }
        .custom-tabs + .tab-content > .tab-pane:not(.active) {
          display: none !important;
        }
        /* Shrink Tab Titles and ensure scroll container can shrink */
        .custom-tabs .nav-link {
          font-size: 0.78rem !important;
          padding: 0.4rem 0.8rem !important;
        }
        .custom-scrollbar {
          min-height: 0 !important;
        }
        .custom-scrollbar::-webkit-scrollbar { width: 6px; height: 6px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 10px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
      `}</style>

      {/* NAVBAR */}
      <nav className="navbar navbar-expand-xl navbar-dark shadow-sm" style={styles.navbarCustom}>
        <Container fluid>
          <a className="navbar-brand d-flex align-items-center me-3" href="#home" onClick={(e) => { e.preventDefault(); navigate('/home'); }}>
            <div className="d-flex align-items-center justify-content-center me-2 rounded bg-white bg-opacity-10 p-1">
              <i className="bi bi-shield-plus text-warning fs-4"></i>
            </div>
            <div>
              <div className="fw-bold text-white lh-1" style={{ fontSize: '0.95rem' }}>SIMRS2 <span className="text-teal" style={{ fontSize: '0.78rem' }}>Finance</span></div>
              <div className="text-white-50 small" style={{ fontSize: '0.62rem' }}>Sistem Informasi Rumah Sakit</div>
            </div>
          </a>

          <div className="d-flex align-items-center text-white text-end gap-3 ms-auto">
            <div className="small border-end pe-3 border-light border-opacity-25 d-none d-sm-block">
              <div className="fw-semibold text-white-50" style={{ fontSize: '0.73rem' }}>{time.date}</div>
              <div className="fw-bold text-teal" style={{ fontSize: '0.78rem' }}>{time.clock}</div>
            </div>
            <Button variant="light" size="sm" onClick={() => navigate('/home')} className="d-flex align-items-center gap-1">
              <i className="bi bi-house-door-fill text-teal"></i>
              <span>Kembali</span>
            </Button>
          </div>
        </Container>
      </nav>

      {/* MAIN CONTENT */}
      <div style={styles.mainContent}>
        <Row className="g-2 flex-grow-1" style={{ overflow: 'hidden' }}>
          <Col lg={12} className="h-100 d-flex flex-column" style={{ minHeight: 0 }}>
            
            <Tabs defaultActiveKey="divisi" id="divisi-tabs" className="custom-tabs mb-2 fw-semibold">
              
              {/* TAB DATA DIVISI */}
              <Tab eventKey="divisi" title={<span><i className="bi bi-diagram-3-fill me-2"></i>Master Data Divisi</span>}>
                <Card className="shadow-sm border-0 h-100">
                  <div className="bg-primary bg-opacity-10 px-3 py-2 border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2 flex-shrink-0">
                    <span className="fw-bold text-primary"><i className="bi bi-table me-2"></i>Tabel Master Divisi</span>
                    <Button variant="primary" size="sm" onClick={fetchDivisi} disabled={isLoading} style={{ fontSize: '0.75rem' }}>
                      {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload Data
                    </Button>
                  </div>
                  
                  <Card.Body className="p-3 d-flex flex-column h-100" style={{ minHeight: 0 }}>
                    {/* Filter Row Divisi */}
                    <Row className="g-2 mb-2 align-items-center flex-shrink-0">
                      <Col md={5}>
                        <InputGroup size="sm">
                          <InputGroup.Text className="bg-light text-muted"><i className="bi bi-search"></i></InputGroup.Text>
                          <Form.Control
                            type="text"
                            placeholder="Cari Nama Divisi atau Owner..."
                            value={searchQuery}
                            onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                            style={{ fontSize: '0.78rem' }}
                          />
                        </InputGroup>
                      </Col>
                      <Col md={2} className="ms-auto text-end">
                        <Form.Select 
                          size="sm" 
                          value={itemsPerPage} 
                          onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); setCurrentPageSub(1); }}
                          style={{ fontSize: '0.78rem' }}
                        >
                          <option value={10}>10 Baris</option>
                          <option value={20}>20 Baris</option>
                          <option value={50}>50 Baris</option>
                        </Form.Select>
                      </Col>
                    </Row>

                    {/* Pagination Controls Divisi */}
                    <div className="d-flex justify-content-center mb-2 flex-shrink-0">
                        <Pagination size="sm" className="mb-0">
                          <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                          <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                          {[...Array(totalPages)].map((_, index) => (
                            <Pagination.Item
                              key={index + 1}
                              active={index + 1 === currentPage}
                              onClick={() => setCurrentPage(index + 1)}
                            >
                              {index + 1}
                            </Pagination.Item>
                          ))}
                          <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages || totalPages === 0} />
                          <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages || totalPages === 0} />
                        </Pagination>
                    </div>

                    {fetchError && (
                      <div className="alert alert-warning py-1.5 px-3 mb-2 flex-shrink-0" style={{ fontSize: '0.75rem' }}>
                        <i className="bi bi-exclamation-triangle-fill me-1"></i> {fetchError}
                      </div>
                    )}

                    {/* Table Area Divisi */}
                    <div className="table-responsive flex-grow-1 custom-scrollbar" style={{ overflowY: 'auto' }}>
                      <Table responsive striped bordered hover size="sm" className="align-middle mb-0 table-compact">
                        <thead className="table-primary sticky-top text-center">
                          <tr>
                            <th style={{ width: '60px' }}>No</th>
                            <th style={{ width: '120px' }}>Kode Divisi</th>
                            <th>Nama Divisi</th>
                            <th>Owner</th>
                            <th>NIK Owner</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <tr>
                              <td colSpan="5" className="text-center py-5 text-primary">
                                <Spinner animation="border" variant="primary" className="mb-2" />
                                <div>Memuat data divisi...</div>
                              </td>
                            </tr>
                          ) : currentItems.length > 0 ? (
                            currentItems.map((item, idx) => (
                              <tr key={idx} className="text-center">
                                <td>{indexOfFirstItem + idx + 1}</td>
                                <td className="fw-bold">{item.kd_divisi}</td>
                                <td className="text-start fw-semibold text-dark">{item.nm_divisi || '-'}</td>
                                <td className="text-start text-primary fw-semibold">{item.owner || '-'}</td>
                                <td className="font-monospace text-muted">{item.nik || '-'}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center text-muted py-4">Tidak ada data divisi ditemukan.</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Card.Body>
                </Card>
              </Tab>

              {/* TAB DATA SUB DIVISI */}
              <Tab eventKey="subdivisi" title={<span><i className="bi bi-diagram-2 me-2"></i>Data Sub Divisi</span>}>
                <Card className="shadow-sm border-0 h-100">
                  <div className="bg-success bg-opacity-10 px-3 py-2 border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2 flex-shrink-0">
                    <span className="fw-bold text-success"><i className="bi bi-table me-2"></i>Tabel Master Sub Divisi</span>
                    <Button variant="success" size="sm" onClick={fetchSubDivisi} disabled={isLoadingSub} style={{ fontSize: '0.75rem' }}>
                      {isLoadingSub ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload Data
                    </Button>
                  </div>
                  
                  <Card.Body className="p-3 d-flex flex-column h-100" style={{ minHeight: 0 }}>
                    {/* Filter Row Sub Divisi */}
                    <Row className="g-2 mb-2 align-items-center flex-shrink-0">
                      <Col md={3}>
                        <Form.Select 
                          size="sm" 
                          value={selectedKdDivisi} 
                          onChange={(e) => { setSelectedKdDivisi(e.target.value); setCurrentPageSub(1); }}
                          style={{ fontSize: '0.78rem' }}
                        >
                          <option value="">Semua Divisi</option>
                          {divisiList.map((d, i) => (
                            <option key={i} value={d.kd_divisi}>{d.kd_divisi} - {d.nm_divisi}</option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col md={4}>
                        <InputGroup size="sm">
                          <InputGroup.Text className="bg-light text-muted"><i className="bi bi-search"></i></InputGroup.Text>
                          <Form.Control
                            type="text"
                            placeholder="Cari Sub Divisi..."
                            value={searchSubQuery}
                            onChange={(e) => { setSearchSubQuery(e.target.value); setCurrentPageSub(1); }}
                            style={{ fontSize: '0.78rem' }}
                          />
                        </InputGroup>
                      </Col>
                      <Col md={2} className="ms-auto text-end">
                        <Form.Select 
                          size="sm" 
                          value={itemsPerPage} 
                          onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); setCurrentPageSub(1); }}
                          style={{ fontSize: '0.78rem' }}
                        >
                          <option value={10}>10 Baris</option>
                          <option value={20}>20 Baris</option>
                          <option value={50}>50 Baris</option>
                        </Form.Select>
                      </Col>
                    </Row>

                    {/* Pagination Controls Sub Divisi */}
                    <div className="d-flex justify-content-center mb-2 flex-shrink-0">
                        <Pagination size="sm" className="mb-0">
                          <Pagination.First onClick={() => setCurrentPageSub(1)} disabled={currentPageSub === 1} />
                          <Pagination.Prev onClick={() => setCurrentPageSub(prev => Math.max(prev - 1, 1))} disabled={currentPageSub === 1} />
                          {[...Array(totalPagesSub)].map((_, index) => (
                            <Pagination.Item
                              key={index + 1}
                              active={index + 1 === currentPageSub}
                              onClick={() => setCurrentPageSub(index + 1)}
                            >
                              {index + 1}
                            </Pagination.Item>
                          ))}
                          <Pagination.Next onClick={() => setCurrentPageSub(prev => Math.min(prev + 1, totalPagesSub))} disabled={currentPageSub === totalPagesSub || totalPagesSub === 0} />
                          <Pagination.Last onClick={() => setCurrentPageSub(totalPagesSub)} disabled={currentPageSub === totalPagesSub || totalPagesSub === 0} />
                        </Pagination>
                    </div>

                    {fetchErrorSub && (
                      <div className="alert alert-warning py-1.5 px-3 mb-2 flex-shrink-0" style={{ fontSize: '0.75rem' }}>
                        <i className="bi bi-exclamation-triangle-fill me-1"></i> {fetchErrorSub}
                      </div>
                    )}

                    {/* Table Area Sub Divisi */}
                    <div className="table-responsive flex-grow-1 custom-scrollbar" style={{ overflowY: 'auto' }}>
                      <Table responsive striped bordered hover size="sm" className="align-middle mb-0 table-compact">
                        <thead className="table-success sticky-top text-center">
                          <tr>
                            <th style={{ width: '60px' }}>No</th>
                            <th style={{ width: '120px' }}>Kode Sub Divisi</th>
                            <th>Nama Sub Divisi / NIK</th>
                            <th>Nama Induk Divisi</th>
                            <th>Kode Induk</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoadingSub ? (
                            <tr>
                              <td colSpan="5" className="text-center py-5 text-success">
                                <Spinner animation="border" variant="success" className="mb-2" />
                                <div>Memuat data sub divisi...</div>
                              </td>
                            </tr>
                          ) : currentItemsSub.length > 0 ? (
                            currentItemsSub.map((item, idx) => (
                              <tr key={idx} className="text-center">
                                <td>{indexOfFirstItemSub + idx + 1}</td>
                                <td className="fw-bold">{item.kode}</td>
                                <td className="text-start fw-semibold text-dark">{item.nik || '-'}</td>
                                <td className="text-start text-success fw-semibold">{item.nm_divisi || '-'}</td>
                                <td className="text-muted fw-bold">{item.kd_divisi}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center text-muted py-4">Tidak ada data sub divisi ditemukan.</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Card.Body>
                </Card>
              </Tab>

            </Tabs>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default DataDivisi;
